import { render, staticRenderFns } from "./i-array-sort.vue?vue&type=template&id=07ba0534&scoped=true&"
import script from "./i-array-sort.vue?vue&type=script&lang=js&"
export * from "./i-array-sort.vue?vue&type=script&lang=js&"
import style0 from "./i-array-sort.vue?vue&type=style&index=0&id=07ba0534&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba0534",
  null
  
)

export default component.exports